
import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('deliveryToken');
        const savedUser = localStorage.getItem('deliveryUser');

        if (token && savedUser) {
          // Optionally verify token with backend
          setUser(JSON.parse(savedUser));
        }
      } catch (error) {
        console.error('Error loading user session:', error);
        localStorage.removeItem('deliveryToken');
        localStorage.removeItem('deliveryUser');
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = (userData, token) => {
    localStorage.setItem('deliveryToken', token);
    localStorage.setItem('deliveryUser', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('deliveryToken');
    localStorage.removeItem('deliveryUser');
    setUser(null);
  };

  const updateUser = (updatedUserData) => {
    localStorage.setItem('deliveryUser', JSON.stringify(updatedUserData));
    setUser(updatedUserData);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

